var logger=console;export function getLogger(){return logger}export function setLogger(newLogger){logger=newLogger}